// Dependecies
import React from 'react';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import Popup from 'reactjs-popup';
import { useParams } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

// Components
import Template from '../components/Template';
import PasswordChangeInput from '../components/PasswordChangeInput';
import check from '../../sass/images/icono-check.svg';
import alert from '../../sass/images/alert/alert.svg';

// Hooks
import useChangePassword from '../hooks/useChangePassword';

function NewPassword({ t }) {
  const { token } = useParams();

  const { control, handleSubmit, watch, errors, clearErrors, setError } = useForm();
  const { closeModal, openModal, validatePassword, submit } = useChangePassword(
    token,
    clearErrors,
    setError
  );
  return (
    <Template
      component="newPassword"
      type={2}
      classNameContainer="change_password"
      className="container_menu background change_password"
    >
      <form action="" onSubmit={handleSubmit(submit)}>
        <div className="row data">
          <div className="col" />
          <div className="col-sm-12 col-md-6">
            <h1 className="with_sub">
              <strong>{t('recover-password')}</strong>
            </h1>
            <p className="with_sub">{t('enter-password')}</p>
            <div className="row">
              <div className="col">
                <label
                  htmlFor="newpassword"
                  className={`col-form-label ${errors.newpassword ? 'error_label' : ''}`}
                >
                  {t('new-password')}
                </label>
                <div className="content_pass">
                  <Controller
                    render={({ value, onChange }) => (
                      <PasswordChangeInput
                        min={8}
                        value={value}
                        onBlur={onChange}
                        className="form-control"
                      />
                    )}
                    rules={{
                      validate: (value) =>
                        validatePassword(value, watch('newpasswordcomfirm'), 'newpasswordcomfirm'),
                    }}
                    control={control}
                    id="newpassword"
                    name="newpassword"
                  />
                  {errors.newpassword && (
                    <div className="error_input">
                      <p>
                        <img src={alert} alt={t('alt:notification')} />
                        {errors.newpassword.message &&
                        errors.newpassword.message === 'Password is empty'
                          ? t('enter')
                          : t('passwords-not-match')}
                      </p>
                    </div>
                  )}
                  <br />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label
                  htmlFor="newpasswordcomfirm"
                  className={`col-form-label ${errors.newpasswordcomfirm ? 'error_label' : ''}`}
                >
                  {t('confirm-password')}
                </label>
                <div className="content_pass">
                  <Controller
                    render={({ value, onChange }) => (
                      <PasswordChangeInput
                        min={8}
                        value={value}
                        onBlur={onChange}
                        className="form-control"
                      />
                    )}
                    rules={{
                      validate: (value) =>
                        validatePassword(value, watch('newpassword'), 'newpassword'),
                    }}
                    control={control}
                    id="newpasswordcomfirm"
                    name="newpasswordcomfirm"
                  />
                  {errors.newpasswordcomfirm && (
                    <div className="error_input">
                      <p>
                        <img src={alert} alt={t('alt:notification')} />
                        {errors.newpasswordcomfirm.message &&
                        errors.newpasswordcomfirm.message === 'Password is empty'
                          ? t('enter-confirm-password')
                          : t('passwords-not-match')}
                      </p>
                    </div>
                  )}
                  <br />
                </div>
              </div>
            </div>
          </div>
          <div className="col" />
        </div>
        <div className="row">
          <div className="col" />
          <div className="col-sm-12 col-md-6 with_sub">
            <input
              type="submit"
              className="col btn btn-primary send_register send_recovery"
              value={t('confirm')}
            />
          </div>
          <div className="col" />
        </div>
      </form>
      {openModal ? (
        <div className="modal-design">
          <Popup open={openModal}>
            <div className="modal-reset">
              <button type="button" className="close" onClick={closeModal}>
                &times;
              </button>
              <div className="modal-content">
                <h3> {t('successful-password-change')} </h3>
                <div className="modal-heading-box">
                  <img className="modal-image" src={check} alt={t('alt:response')} />
                </div>
                <div className="modal-form">
                  <div className="modal-img-box">
                    <p> {t('changed-successfully')} </p>
                  </div>
                  <button type="button" className="close_modal" onClick={closeModal}>
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </Popup>
        </div>
      ) : (
        ''
      )}
    </Template>
  );
}

NewPassword.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['changePassword', 'alt'])(NewPassword);
